"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBookInteriorDesignOptions;
const either_1 = require("../../types/either");
const isDesignAllowedForPrintableIdx_1 = __importDefault(require("./isDesignAllowedForPrintableIdx"));
const isDesignAllowedForPageCount_1 = __importDefault(require("./isDesignAllowedForPageCount"));
// used in editor 
function getBookInteriorDesignOptions(template, interiorPrintableIdx, interiorPrintableCount) {
  const interiorDesigns = template.designs.filter(d => (0, isDesignAllowedForPrintableIdx_1.default)(d, interiorPrintableIdx) && (0, isDesignAllowedForPageCount_1.default)(d, interiorPrintableCount));
  if ((interiorDesigns === null || interiorDesigns === void 0 ? void 0 : interiorDesigns.length) > 0) return (0, either_1.right)(interiorDesigns);
  return (0, either_1.left)(new Error(`Error getting interior design options: ${JSON.stringify(interiorDesigns)}`));
}